import React, { type ReactNode } from 'react';

import classnames from 'classnames';

import { Icon } from '../../../../Icon/Icon';
import { useSelectRootContext } from '../../root/SelectRootContext';

import styles from './SelectArrow.module.scss';

type SelectArrowProps = {
    children?: ReactNode;
};

export const SelectArrow = ({ children }: SelectArrowProps) => {
    const { open, disabled } = useSelectRootContext();
    return (
        <span
            className={classnames(styles.arrow, {
                [styles.open]: open,
                [styles.disabled]: disabled
            })}
            aria-hidden="true"
        >
            {children ?? <Icon name="s-icon-arrow-chevron-down" className={styles.icon} />}
        </span>
    );
};
